import { ItemStatus } from "./Item"

export class PostMortemCreate {
  itemId: string
  whys: string[]
  resolution: string
  status: ItemStatus
}

export class PostMortem {
  itemId: string
  resolution: string
  whys: string[]
  status: ItemStatus
  constructor(props: Partial<PostMortemCreate>) {
    const { itemId, resolution, whys } = props

    this.itemId = itemId ?? ""
    this.resolution = resolution ?? ""

    this.whys = whys ?? []
    this.status = props.status ?? "NOT_STARTED"
  }

  static create(props: Partial<PostMortemCreate>): PostMortem {
    return new PostMortem(props)
  }

  getJsonObj() {
    const data = {
      itemId: this.itemId,
      resolution: this.resolution,
      whys: this.whys
    }

    return data
  }
}
